import React, {FC} from 'react';
import { IGeneralInfoState } from '../../../../common/state/subscriptions/general_info';
import { IPaymentInfoState } from '../../../../common/state/subscriptions/payment_info';
import { IPersonalInfoState } from '../../../../common/state/subscriptions/personal_info';
import { useSelector } from 'react-redux';
// custom



const SubscriptionDetailsView : FC = () => {
    const payment_info = useSelector(({payment_info}: {payment_info: IPaymentInfoState}) => payment_info.selected);
    const personal_info = useSelector(({personal_info}: {personal_info: IPersonalInfoState}) => personal_info.selected);
    const general_info = useSelector(({general_info}: {general_info: IGeneralInfoState}) => general_info.selected);

    console.log('Subscription information details: ', general_info, payment_info, personal_info);
    return <React.Fragment>        
        <main
            className="flex flex-col items-start justify-start w-full min-h-screen text-gray-700 bg-gray-200 dark:bg-gray-800 dark:text-teal-400">            
            <section
                className="flex flex-col items-start justify-start w-full p-4 my-3 mr-3 bg-white shadow-lg grow rounded-xl dark:bg-gray-900">
                <h2 className="text-xl font-semibold leading-8 text-indigo-600 dark:text-teal-400">Payment option: {general_info?.payment_type} | Subscription Status: {general_info?.status}</h2>                
                <hr
                    className="inline-flex w-full my-4 border-gray-400 border-dashed border-bottom dark:border-gray-300" />
                {/* Personal Information */}
                <article className="w-full overflow-hidden bg-white shadow sm:rounded-lg">
                    <div className="px-2 py-5">
                        <h2 className="text-2xl font-semibold leading-8 text-indigo-600">Attendee Details</h2>
                        <p className="max-w-2xl mt-1 text-sm text-gray-500">Personal details and application of the attendee.</p>
                    </div>
                    <div className="border-t border-gray-200">
                        <dl>
                            <div className="px-4 py-5 bg-gray-50 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                <dt className="font-medium text-gray-500 text-md">Name (Passport):</dt>
                                <dd className="mt-1 font-bold text-gray-700 text-md sm:col-span-2 sm:mt-0">{personal_info?.first_name} {personal_info?.last_name}</dd>
                            </div>
                            <div className="px-4 py-5 bg-gray-50 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                <dt className="font-medium text-gray-500 text-md">Passport #</dt>
                                <dd className="mt-1 font-bold text-gray-700 text-md sm:col-span-2 sm:mt-0">{personal_info?.passport}</dd>
                            </div>
                            {/*Contact Number*/}
                            <div className="px-4 py-5 bg-gray-50 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                <dt className="font-medium text-gray-500 text-md">Contact (WHATSAPP) #</dt>
                                <dd className="mt-1 font-bold text-gray-700 text-md sm:col-span-2 sm:mt-0">{personal_info?.contact?? '-'}</dd>
                            </div>
                            <div className="px-4 py-5 bg-white sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                <dt className="font-medium text-gray-500 text-md">Attending Event:</dt>
                                <dd className="mt-1 font-bold text-gray-700 text-md sm:col-span-2 sm:mt-0">{general_info?.event_title}</dd>
                            </div>
                            <div className="px-4 py-5 bg-gray-50 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                <dt className="font-medium text-gray-500 text-md">Email address:</dt>
                                <dd className="mt-1 font-bold text-gray-700 text-md sm:col-span-2 sm:mt-0">
                                    {personal_info?.email}</dd>
                            </div>
                            <div className="px-4 py-5 bg-white sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                <dt className="font-medium text-gray-500 text-md">Amount:</dt>
                                <dd className="mt-1 font-bold text-gray-700 text-md sm:col-span-2 sm:mt-0">${general_info?.final_price}</dd>
                            </div>
                            <div className="px-4 py-5 bg-gray-50 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                <dt className="font-medium text-gray-500 text-md">Address:</dt>
                                <dd className="mt-1 font-bold text-gray-700 text-md sm:col-span-2 sm:mt-0">
                                    {personal_info?.address}, {personal_info?.city}, {personal_info?.country}, {personal_info?.pin_code}
                                </dd>
                            </div>
                        </dl>
                    </div>
                </article>
                <hr
                    className="inline-flex w-full my-4 border-gray-400 border-dashed border-bottom dark:border-gray-300" />                                
            </section>
        </main>
    </React.Fragment>
};

export default SubscriptionDetailsView;